import axios from 'axios';
import md5 from 'md5';

import { ACCESS_USERID_KEY } from '@/constant/config';
import { getCookie, setCookie } from '@/utils/cookie';
import Storage from '@/utils/Storage';
import { getBrowser } from '@/utils/utils';

export const implog = async (act: string, data?: string | object, orderid?: string, h3 = 'web') => {
  let remark = data;
  if (typeof data === 'object') {
    remark = JSON.stringify(data);
  }
  const md5Key = 'us_h5_md5_key';
  let md5Val = await getUniqueID();

  if (!md5Val) {
    // 使用 UA + 时间戳 md5 , 保存到 cookie
    md5Val = md5(`${navigator.userAgent}_${Date.now()}`);
    setCookie(md5Key, md5Val);
  }

  const sourceurl = getCookie('us_h5_sourceurl_key');

  const userid = Storage.getAccess(ACCESS_USERID_KEY);

  const source = getAPKCHSource().replace('CH_', '');
  return axios.get('https://active.brl77.com/mxlog', {
    params: {
      host: `us_h5_${h3}_${source}`,
      orderid: orderid || userid,
      act: act,
      md5: md5Val,
      sourceurl,
      remark: remark || '',
      v: __APP_VERSION__,
      browser: getBrowser()
    }
  });
};
